var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M11,32.996c-0.553,0-1,0.448-1,1v6.133c0,0.552,0.447,1,1,1h28c0.553,0,1-0.448,1-1v-6.133 c0-0.552-0.447-1-1-1s-1,0.448-1,1v5.133H12v-5.133C12,33.444,11.553,32.996,11,32.996z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M25,9.129c-0.553,0-1,0.448-1,1v21.51l-6.343-6.127c-0.395-0.384-1.03-0.373-1.413,0.024 c-0.384,0.397-0.373,1.03,0.024,1.414l8.023,7.751c0.001,0.001,0.001,0.001,0.002,0.002l0.012,0.011 c0.037,0.036,0.084,0.051,0.124,0.08c0.062,0.045,0.12,0.095,0.192,0.124c0.121,0.05,0.249,0.076,0.378,0.076 s0.257-0.027,0.378-0.076c0.067-0.027,0.12-0.074,0.178-0.115c0.046-0.031,0.098-0.05,0.139-0.09l8.036-7.765 c0.396-0.384,0.407-1.017,0.023-1.414c-0.384-0.397-1.017-0.408-1.414-0.024L26,31.639v-21.51C26,9.577,25.553,9.129,25,9.129z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/download-button.fc2241e6145d3712183980fda942208f.svg";
export { ForwardRef as ReactComponent };